import {
  Button,
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
} from "@mui/material";
import { useEffect, useState } from "react";
import WarnignModal from "./WarnignModal";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../mui/LoadingOverlay";
import Autogooglecomplete from "./Autogooglecomplete";
import Autocomplete from "@mui/material/Autocomplete";
import { selectnodess } from "../redux/nodesSlice";
import { selectgroups } from "../redux/businessSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the styles for the editor
import AddAdditionalFields from "./AddAdditionalField";
import { currencydata } from "../utils/currency";
import { NumericFormat } from "react-number-format";
import { useCreateOrganizationMutation } from "../redux/organizationApi";

export function ParentOrgForm() {
  const navigate = useNavigate();
  const allorganization = useSelector(selectnodess);
  const [parentOptions, setParentOptions] = useState([]);
  const [sharedata, setSharedata] = useState(0); // Remaining shares
  const [loading, setLoading] = useState(false);
  const groups = useSelector(selectgroups);
  const [open, setOpen] = useState(false);
  const [createOrganization] = useCreateOrganizationMutation();
  // const [additionalFields, setAdditionalFields] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    const data = allorganization?.filter((item) => item.isBranch === false);
    const parents = data?.map((org) => {
      return {
        label: org.data.label,
        value: org.id.toString(),
      };
    });
    setParentOptions(parents);
  }, [allorganization]);

  const initialNode = {
    companyName: "",
    location: { name: "", address: "", lat: "", lng: "", countryName: "" },
    totalNoOfShares: "",
    directors: [""],
    shareHolders: [
      {
        childId: "",
        numberSharesOwned: "",
        PercentageOfShares: "",
        numberofpreferenceshares: "",
        percentageofpreferanceshares: "",
      },
    ],
    additionalFields: [],
    BusinessNature: "",
    registerCurrency: "USD",
    TotalCurrency: "USD",
    ParCurrency: "USD",
    CapitalCurrency: "USD",
    Incorporationdate: "",
    CompanyRegistrationNumber: "",
    BusinessRegistrationNumber: "",
    ManagingDirector: "",
    DeputyManagingDirector: "",
    Chairman: "",
    checked: false,
    AuthorizedCapital: "",
    ResidentDirector: "",
    DeputyChairman: "",
    CompanySecretary: "",
    StatutoryAuditor: "",
    RepresentativeDirector: "",
    LegalRepresentative: "",
    TotalPaidUpCapital: "",
    Remarks: "",
    ParValueofShares: "",
    TotalPaidUpPremiumtoShares: "",
    BusinessGroup: "",
    isOperatingCompany: false,
    isJointVentureCompany: false,
    JointVentureCompanies: [],
    totalIssuedPreferenceShares: "",
  };

  const requiredFields = [
    { key: "location", message: "Location is required" },
    { key: "companyName", message: "Company Name is required" },
    { key: "BusinessNature", message: "Business Nature is required" },
    { key: "Incorporationdate", message: "Incorporation date is required" },
    {
      key: "CompanyRegistrationNumber",
      message: "Company Registration Number is required",
    },
    // { key: "BusinessRegistrationNumber", message: "Business Registration Number is required" },
    // { key: "ManagingDirector", message: "Managing Director is required" },
    // { key: "DeputyManagingDirector", message: "Deputy Managing Director is required" },
    // { key: "Chairman", message: "Chairman is required" },
    // { key: "DeputyChairman", message: "Deputy Chairman is required" },
    // { key: "CompanySecretary", message: "Company Secretary is required" },
    // { key: "StatutoryAuditor", message: "Statutory Auditor is required" },
    // { key: "RepresentativeDirector", message: "Representative Director is required" },
    // { key: "LegalRepresentative", message: "Legal Representative is required" },
    // { key: "Remarks", message: "Remarks is required" },
    // { key: "TotalPaidUpCapital", message: "Total Paid Up Capital is required" },
    // { key: "ParValueofShares", message: "Par Value of Shares is required" },
    // { key: "TotalPaidUpPremiumtoShares", message: "Total PaidUp Premium to Shares is required" },
    { key: "totalNoOfShares", message: "Total No of Shares is required" },
    { key: "BusinessGroup", message: "Business Group is required" },
  ];

  const [nodeData, setNodeData] = useState(initialNode);
  const handleRemarksChange = (value) => {
    setNodeData((prevData) => ({
      ...prevData,
      Remarks: value, // Update Remarks in state
    }));
  };

  const [errors, setErrors] = useState({
    general: {},
    shareholders: [],
    JointVentureCompanies: [],
    directors: [],
    additionalFields: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log("name", name, "vale", value)
    setNodeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddDirector = () => {
    setNodeData((prev) => ({ ...prev, directors: [...prev.directors, ""] }));
  };

  const deleteShareholder = (index) => {
    setNodeData((prev) => ({
      ...prev,
      shareHolders: prev.shareHolders?.filter((_, i) => i !== index),
    }));
  };

  const deleteJoint = (index) => {
    setNodeData((prev) => ({
      ...prev,
      JointVentureCompanies: prev.JointVentureCompanies?.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const deleteDirectors = (index) => {
    setNodeData((prev) => ({
      ...prev,
      directors: prev.directors?.filter((_, i) => i !== index),
    }));
  };

  const handleAddShareHolder = () => {
    setNodeData((prev) => ({
      ...prev,
      shareHolders: [
        ...prev.shareHolders,
        {
          childId: "",
          numberSharesOwned: "",
          PercentageOfShares: 0,
          numberofpreferenceshares: 0,
          percentageofpreferanceshares: 0,
        },
      ],
    }));
  };

  const handleAddShareCompany = () => {
    setNodeData((prev) => ({
      ...prev,
      JointVentureCompanies: [
        ...prev.JointVentureCompanies,
        { companyName: "", numberSharesOwned: "", PercentageOfShares: 0 },
      ],
    }));
  };
  const handleDirectorChange = (index, name) => {
    const newNames = [...nodeData.directors];
    newNames[index] = name;
    setNodeData((prev) => ({ ...prev, directors: newNames }));
  };
  const handleShareHolderChange = (index, field, value) => {
    let updatedShareHolders = [...nodeData.shareHolders];
    updatedShareHolders[index] = {
      ...updatedShareHolders[index],
      [field]: value,
    };
    if (field === "numberSharesOwned" && nodeData.totalNoOfShares > 0) {
      updatedShareHolders[index].PercentageOfShares =
        (value / nodeData.totalNoOfShares) * 100;
    }
    if (
      field === "numberofpreferenceshares" &&
      nodeData.totalIssuedPreferenceShares > 0
    ) {
      updatedShareHolders[index].percentageofpreferanceshares =
        (value / nodeData.totalIssuedPreferenceShares) * 100;
    }
    setNodeData((prev) => ({ ...prev, shareHolders: updatedShareHolders }));
  };
  const handleJointChange = (index, field, value) => {
    let updatedJointVentureCompanies = [...nodeData.JointVentureCompanies];
    updatedJointVentureCompanies[index] = {
      ...updatedJointVentureCompanies[index],
      [field]: value,
    };

    if (field === "numberSharesOwned" && nodeData.totalNoOfShares > 0) {
      updatedJointVentureCompanies[index].PercentageOfShares =
        (value / nodeData.totalNoOfShares) * 100;
    }

    setNodeData((prev) => ({
      ...prev,
      JointVentureCompanies: updatedJointVentureCompanies,
    }));
  };

  const handleTotalSharesChange = (e) => {
    const { value } = e.target;
    const totalShares = parseFloat(value);
    setSharedata(totalShares); // Set the total number of shares
    setNodeData((prevData) => {
      const updatedShareHolders = prevData.shareHolders?.map((shareHolder) => ({
        ...shareHolder,
        PercentageOfShares:
          totalShares > 0
            ? (shareHolder.numberSharesOwned / totalShares) * 100
            : 0,
      }));

      const updatedJointVentureCompanies = prevData.JointVentureCompanies?.map(
        (jointCompany) => ({
          ...jointCompany,
          PercentageOfShares:
            totalShares > 0
              ? (jointCompany.numberSharesOwned / totalShares) * 100
              : 0,
        })
      );

      return {
        ...prevData,
        totalNoOfShares: totalShares,
        shareHolders: updatedShareHolders,
        JointVentureCompanies: updatedJointVentureCompanies,
      };
    });
  };
  const handleTotalChange = (e) => {
    const { value } = e.target;
    const totalShares = parseFloat(value);
    // console.log(totalShares, "this is vqz")

    setNodeData((prevData) => {
      // console.log(prevData.shareHolders,"this is data")
      const updatedShareHolders = prevData.shareHolders?.map((shareHolder) => ({
        ...shareHolder,
        percentageofpreferanceshares:
          totalShares > 0
            ? (shareHolder?.numberofpreferenceshares * 100) / totalShares
            : 0,
      }));

      return {
        ...prevData,
        totalIssuedPreferenceShares: totalShares,
        shareHolders: updatedShareHolders,
      };
    });
  };

  const validateInput = () => {
    const errorObject = {
      general: {},
      shareholders: [],
      JointVentureCompanies: [],
      additionalFields: [], // Initialize additionalFields as an empty array
    };

    // Validate required fields for general company information
    requiredFields?.forEach((field) => {
      if (
        !nodeData[field.key] ||
        (field.key === "location" &&
          (!nodeData.location.name ||
            !nodeData.location.address ||
            nodeData.location.lat === null ||
            nodeData.location.lng === null))
      ) {
        errorObject.general[field.key] = field.message;
      }
    });

    // Validate Shareholders
    nodeData.shareHolders?.forEach((shareholder, index) => {
      const shareholderErrors = {};
      if (!shareholder.childId) {
        shareholderErrors.childId = "Shareholder is required";
      }
      if (!shareholder.numberSharesOwned) {
        shareholderErrors.numberSharesOwned =
          "Number of Ordinary Shares is required";
      }
      const selectedParents = nodeData.shareHolders?.map((sh) => sh.childId);
      if (selectedParents.indexOf(shareholder.childId) !== index) {
        shareholderErrors.childId = "Shareholder is already added";
      }
      errorObject.shareholders[index] = shareholderErrors;
    });

    // Validate Additional Fields
    nodeData?.additionalFields?.forEach((obj, index) => {
      const errorsdata = {};
      if (obj?.fieldName.trim() === "") {
        errorsdata.fieldName = "Field name is required";
      }
      if (obj?.fieldValue.trim() === "") {
        errorsdata.fieldValue = "Field value is required";
      }
      errorObject.additionalFields[index] = errorsdata;
    });

    // Validate Joint Venture Companies
    if (nodeData?.JointVentureCompanies?.length) {
      nodeData.JointVentureCompanies?.forEach((company, index) => {
        const companyErrors = {};
        if (!company.companyName || company.companyName === "") {
          companyErrors.companyName = "Company Name is required";
        }
        if (!company.numberSharesOwned) {
          companyErrors.numberSharesOwned = "Number of Shares is required";
        }
        errorObject.JointVentureCompanies[index] = companyErrors;
      });
    }

    setErrors(errorObject);

    return (
      Object.keys(errorObject.general).length === 0 &&
      errorObject.shareholders.every((e) => Object.keys(e).length === 0) &&
      errorObject.additionalFields.every((e) => Object.keys(e).length === 0) &&
      errorObject.JointVentureCompanies.every(
        (e) => Object.keys(e).length === 0
      )
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateInput()) {
      return;
    }
    let whollyOwnedCompany = sharedata === 0;
    // console.log("nodeData", nodeData)
    // return
    try {
      setLoading(true);
      await createOrganization({
        ...nodeData,
        isRoot: false,
        whollyCompany: whollyOwnedCompany,
      }).unwrap();
      toast.success(`Company added successfully!`);
      setNodeData(initialNode);
      navigate("/admin/GroupCompanies");
    } catch (error) {
      console.error("Error adding Node:", error);
      toast.error(error?.data?.message || error?.error || "Failed to add Node");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const totalShareholdersShares = nodeData.shareHolders.reduce(
      (acc, item) => acc + parseFloat(item.numberSharesOwned || 0),
      0
    );
    const totalJointVentureShares = nodeData.JointVentureCompanies.reduce(
      (acc, item) => acc + parseFloat(item.numberSharesOwned || 0),
      0
    );

    // Remaining shares available to distribute
    const remainingShares =
      nodeData.totalNoOfShares -
      (totalShareholdersShares + totalJointVentureShares);
    setSharedata(remainingShares); // Updates the remaining shares count
  }, [nodeData]);

  const handleCheckboxChange = (event) => {
    setNodeData({
      ...nodeData,
      [event.target.name]: event.target.checked,
    });
  };
  const handleCheck = (event) => {
    setNodeData({
      ...nodeData,
      checked: true,
      [event.target.name]: event.target.checked, // Set checked to true on click
    });
  };
  const handleCheckbox = (event) => {
    if (event.target.checked === true) {
      setNodeData({
        ...nodeData,
        [event.target.name]: event.target.checked,
      });
      handleAddShareCompany();
    } else {
      setNodeData({
        ...nodeData,
        [event.target.name]: event.target.checked,
        JointVentureCompanies: [],
      });
    }
  };

  // Additional Fields  COde

  return (
    <>
      {open && (
        <WarnignModal
          handleClose={handleClose}
          open={open}
          from="ParentOrganizationForm"
        />
      )}
      <div className="pe-5 ps-1">
        <h2 className="text-center my-4">Add Company</h2>
        <Grid
          container
          spacing={2}
          className="border shadow"
          style={{ backgroundColor: "#0057EB08" }}
          sx={{ maxWidth: 900, mx: "auto", p: 3, mt: 5 }}
          justifyContent="flex-end"
        >
          <Grid item xs={12} sm={6}>
            <TextField
              label="Company Name"
              name="companyName"
              id="outlined-basic"
              value={nodeData.companyName}
              onChange={handleChange}
              error={Boolean(errors.general.companyName)}
              fullWidth
              helperText={errors.general.companyName}
              variant="outlined"
              size="small"
            />
          </Grid>
          {/* business group */}
          <Grid item xs={12} sm={6}>
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              error={Boolean(errors.general.BusinessNature)}
            >
              <InputLabel>Business Groups</InputLabel>
              <Select
                name="BusinessGroup"
                value={nodeData.BusinessGroup}
                onChange={handleChange}
                label="Business Groups"
              >
                {groups?.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item._id}>
                      {item?.businessNature?.charAt(0)?.toUpperCase() +
                        item?.businessNature?.slice(1)}
                    </MenuItem>
                  );
                })}
              </Select>
              {errors.general.BusinessGroup && (
                <small style={{ color: "red" }}>
                  {errors.general.BusinessGroup}
                </small>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Business Nature"
              name="BusinessNature"
              // id="outlined-basic"
              value={nodeData.BusinessNature}
              onChange={handleChange}
              error={Boolean(errors.general.BusinessNature)}
              fullWidth
              helperText={errors.general.BusinessNature}
              variant="outlined"
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Autogooglecomplete setNodeData={setNodeData} errors={errors} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Incorporation Date"
              type="date"
              name="Incorporationdate"
              id="outlined-basic"
              value={nodeData.Incorporationdate}
              onChange={handleChange}
              error={Boolean(errors.general.Incorporationdate)}
              fullWidth
              helperText={errors.general.Incorporationdate}
              variant="outlined"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Managing Director"
              name="ManagingDirector"
              id="outlined-basic"
              value={nodeData.ManagingDirector}
              onChange={handleChange}
              error={Boolean(errors.general.ManagingDirector)}
              fullWidth
              helperText={errors.general.ManagingDirector}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label=" Business Registration Number"
              name="BusinessRegistrationNumber"
              id="outlined-basic"
              value={nodeData.BusinessRegistrationNumber}
              onChange={handleChange}
              error={Boolean(errors.general.BusinessRegistrationNumber)}
              fullWidth
              helperText={errors.general.BusinessRegistrationNumber}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Deputy Managing Director"
              name="DeputyManagingDirector"
              id="outlined-basic"
              value={nodeData.DeputyManagingDirector}
              onChange={handleChange}
              error={Boolean(errors.general.DeputyManagingDirector)}
              fullWidth
              helperText={errors.general.DeputyManagingDirector}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Company Registration Number"
              name="CompanyRegistrationNumber"
              id="outlined-basic"
              value={nodeData.CompanyRegistrationNumber}
              onChange={handleChange}
              error={Boolean(errors.general.CompanyRegistrationNumber)}
              fullWidth
              helperText={errors.general.CompanyRegistrationNumber}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Chairman"
              name="Chairman"
              id="outlined-basic"
              value={nodeData.Chairman}
              onChange={handleChange}
              error={Boolean(errors.general.Chairman)}
              fullWidth
              helperText={errors.general.Chairman}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.TotalPaidUpCapital}
              thousandSeparator
              customInput={TextField}
              label="Registered/Issued Paid-up Capital"
              name="TotalPaidUpCapital"
              size="small"
              variant="outlined"
              fullWidth
              helperText={errors.general.TotalPaidUpCapital}
              error={Boolean(errors.general.TotalPaidUpCapital)}
              onValueChange={(values) => {
                handleChange({
                  target: {
                    name: "TotalPaidUpCapital",
                    value: values.value,
                  },
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TextField
                      select
                      name="registerCurrency"
                      value={nodeData.registerCurrency || "USD"}
                      onChange={handleChange}
                      variant="standard"
                      style={{ width: 70 }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 250,

                              overflowY: "auto",
                            },
                          },
                        },
                      }}
                    >
                      {currencydata?.map((currency) => (
                        <MenuItem key={currency} value={currency}>
                          {currency}
                        </MenuItem>
                      ))}
                    </TextField>
                  </InputAdornment>
                ),
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Deputy Chairman"
              name="DeputyChairman"
              id="outlined-basic"
              value={nodeData.DeputyChairman}
              onChange={handleChange}
              error={Boolean(errors.general.DeputyChairman)}
              fullWidth
              helperText={errors.general.DeputyChairman}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.TotalPaidUpPremiumtoShares}
              thousandSeparator
              customInput={TextField}
              label="Total Paid Up Premium to Shares/Share Premium"
              name="TotalPaidUpPremiumtoShares"
              size="small"
              variant="outlined"
              fullWidth
              error={Boolean(errors.general.TotalPaidUpPremiumtoShares)}
              helperText={errors.general.TotalPaidUpPremiumtoShares}
              onValueChange={(values) => {
                handleChange({
                  target: {
                    name: "TotalPaidUpPremiumtoShares",
                    value: values.value,
                  },
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TextField
                      select
                      defaultValue="USD"
                      name="TotalCurrency"
                      onChange={handleChange}
                      variant="standard"
                      style={{ width: 70 }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 250, // Scrollable dropdown height
                              overflowY: "auto", // Enable vertical scrolling
                            },
                          },
                        },
                      }}
                    >
                      {currencydata?.map((currency) => (
                        <MenuItem key={currency} value={currency}>
                          {currency}
                        </MenuItem>
                      ))}
                    </TextField>
                  </InputAdornment>
                ),
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            // onBlur={handleSave} // Save on blur (optional)
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Company Secretary"
              name="CompanySecretary"
              id="outlined-basic"
              value={nodeData.CompanySecretary}
              onChange={handleChange}
              error={Boolean(errors.general.CompanySecretary)}
              fullWidth
              helperText={errors.general.DeputyChairman}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.ParValueofShares}
              thousandSeparator
              customInput={TextField}
              label="Par Value of Shares"
              name="ParValueofShares"
              size="small"
              variant="outlined"
              fullWidth
              error={Boolean(errors.general.ParValueofShares)}
              helperText={errors.general.ParValueofShares}
              onValueChange={(values) => {
                handleChange({
                  target: {
                    name: "ParValueofShares",
                    value: values.value,
                  },
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TextField
                      select
                      name="ParCurrency"
                      onChange={handleChange}
                      variant="standard"
                      defaultValue="USD"
                      style={{ width: 70 }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 250, // Scrollable dropdown height
                              overflowY: "auto", // Enable vertical scrolling
                            },
                          },
                        },
                      }}
                    >
                      {currencydata?.map((currency) => (
                        <MenuItem key={currency} value={currency}>
                          {currency}
                        </MenuItem>
                      ))}
                    </TextField>
                  </InputAdornment>
                ),
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            // onBlur={handleSave} // Save on blur (optional)
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Representative / General Director"
              name="RepresentativeDirector"
              id="outlined-basic"
              value={nodeData.RepresentativeDirector}
              onChange={handleChange}
              error={Boolean(errors.general.RepresentativeDirector)}
              fullWidth
              helperText={errors.general.RepresentativeDirector}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.AuthorizedCapital}
              thousandSeparator
              customInput={TextField}
              label="Authorized Capital"
              name="AuthorizedCapital"
              id="outlined-basic"
              error={Boolean(errors.general.AuthorizedCapital)}
              fullWidth
              helperText={errors.general.AuthorizedCapital}
              variant="outlined"
              size="small"
              onValueChange={(values) => {
                handleChange({
                  target: {
                    name: "AuthorizedCapital",
                    value: values.value,
                  },
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TextField
                      select
                      name="CapitalCurrency"
                      onChange={handleChange}
                      variant="standard"
                      defaultValue="USD"
                      style={{ width: 70 }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 250, // Scrollable dropdown height
                              overflowY: "auto", // Enable vertical scrolling
                            },
                          },
                        },
                      }}
                    >
                      {currencydata?.map((currency) => (
                        <MenuItem key={currency} value={currency}>
                          {currency}
                        </MenuItem>
                      ))}
                    </TextField>
                  </InputAdornment>
                ),
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Resident Director"
              name="ResidentDirector"
              id="outlined-basic"
              value={nodeData.ResidentDirector}
              onChange={handleChange}
              error={Boolean(errors.general.ResidentDirector)}
              fullWidth
              helperText={errors.general.ResidentDirector}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.totalIssuedPreferenceShares}
              thousandSeparator
              customInput={TextField}
              label="Total Issued Preference Shares"
              variant="outlined"
              name="totalIssuedPreferenceShares"
              size="small"
              fullWidth
              error={Boolean(errors.general.totalIssuedPreferenceShares)}
              helperText={errors.general.totalIssuedPreferenceShares}
              onValueChange={(values) => {
                handleTotalChange({
                  target: {
                    name: "totalIssuedPreferenceShares",
                    value: values.value,
                  },
                });
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.totalNoOfShares}
              thousandSeparator
              customInput={TextField}
              label="Total Issued Ordinary Shares"
              variant="outlined"
              name="totalNoOfShares"
              size="small"
              fullWidth
              error={Boolean(errors.general.totalNoOfShares)}
              helperText={errors.general.totalNoOfShares}
              onValueChange={(values) => {
                handleTotalSharesChange({
                  target: {
                    name: "totalNoOfShares",
                    value: values.value,
                  },
                });
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Legal Representative"
              name="LegalRepresentative"
              id="outlined-basic"
              value={nodeData.LegalRepresentative}
              onChange={handleChange}
              error={Boolean(errors.general.LegalRepresentative)}
              fullWidth
              helperText={errors.general.LegalRepresentative}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Statutory Auditor"
              name="StatutoryAuditor"
              id="outlined-basic"
              value={nodeData.StatutoryAuditor}
              onChange={handleChange}
              error={Boolean(errors.general.StatutoryAuditor)}
              fullWidth
              helperText={errors.general.StatutoryAuditor}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={nodeData.isOperatingCompany}
                  onChange={handleCheckboxChange}
                  name="isOperatingCompany"
                  color="primary"
                />
              }
              label="Operating Company"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={nodeData.checked}
                  onChange={handleCheck}
                  name="checked"
                  color="primary"
                  size="small"
                />
              }
              label="Status: Incorporate In Progress/To be Liquidated"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            // key={index}
            sx={{ alignItems: "right" }}
          >
            {nodeData.directors?.map((dir, index) => (
              <div key={index} className="d-flex w-100 mb-2">
                <TextField
                  label="Director"
                  variant="outlined"
                  value={nodeData.directors[index]}
                  name="Director"
                  onChange={(e) => handleDirectorChange(index, e.target.value)}
                  fullWidth
                  // error={Boolean(errors.directors[index])}
                  // helperText={errors.directors[index]}
                  size="small"
                />
                {index !== 0 && (
                  <DeleteIcon
                    style={{
                      fontSize: "30px",
                      color: "#1976d2",
                      cursor: "pointer",
                      marginLeft: "10px",
                      marginTop: "10px",
                    }}
                    onClick={() => deleteDirectors(index)}
                  />
                )}
              </div>
            ))}
          </Grid>

          <Grid
            item
            xs={12}
            container
            className="d-flex justify-content-between"
            alignItems="center"
          >
            {/* Checkbox for Operating Companies */}

            <Grid item xs={12} sm={6}>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={nodeData?.isJointVentureCompany}
                      onChange={handleCheckbox}
                      name="isJointVentureCompany"
                      color="primary"
                    />
                  }
                  label="Joint Venture Company"
                />
              </Grid>
            </Grid>

            {/* Add Director Button */}
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                endIcon={<AddIcon />}
                onClick={handleAddDirector}
              >
                Add Director
              </Button>
            </Grid>
          </Grid>
          <Grid sx={{ marginTop: "10px", marginBottom: "10px" }} item xs={12}>
            <AddAdditionalFields
              nodeData={nodeData}
              setNodeData={setNodeData}
              errors={errors}
            />
          </Grid>
          {nodeData?.isJointVentureCompany === true && (
            <>
              {nodeData.JointVentureCompanies?.map((shareholder, index) => (
                <Grid
                  container
                  spacing={1}
                  key={index}
                  style={{ marginTop: "5px", marginLeft: "8px" }}
                  alignItems="center"
                >
                  <Grid item xs={12} sm={3}>
                    <TextField
                      label="Company Name"
                      size="small"
                      variant="outlined"
                      type="text"
                      value={shareholder?.companyName}
                      onChange={(e) => {
                        handleJointChange(index, "companyName", e.target.value);
                      }}
                      fullWidth
                      error={Boolean(
                        errors?.JointVentureCompanies[index]?.companyName
                      )}
                      helperText={
                        errors?.JointVentureCompanies[index]?.companyName
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <NumericFormat
                      value={parseFloat(shareholder.numberSharesOwned) || 0}
                      thousandSeparator
                      customInput={TextField}
                      label="Number of Shares Owned"
                      size="small"
                      variant="outlined"
                      fullWidth
                      error={Boolean(
                        errors?.JointVentureCompanies[index]?.numberSharesOwned
                      )}
                      helperText={
                        errors?.JointVentureCompanies[index]?.numberSharesOwned
                      }
                      onValueChange={(values) => {
                        let value = parseFloat(values.value) || 0;

                        // Calculate the total shares that have already been assigned
                        const totalAssignedShares =
                          nodeData.shareHolders.reduce(
                            (acc, item) =>
                              acc + parseFloat(item.numberSharesOwned || 0),
                            0
                          ) +
                          nodeData.JointVentureCompanies.reduce(
                            (acc, item, i) =>
                              i !== index
                                ? acc + parseFloat(item.numberSharesOwned || 0)
                                : acc,
                            0
                          );

                        // Calculate the maximum shares that can be assigned
                        let maxAllowed =
                          nodeData.totalNoOfShares - totalAssignedShares;

                        // If the entered value exceeds the allowed value, set it to the maximum allowed
                        if (value > maxAllowed) {
                          value = maxAllowed;
                        }

                        // Update the state with the validated value
                        handleJointChange(index, "numberSharesOwned", value);
                      }}
                      isAllowed={(values) => {
                        const { floatValue } = values;
                        if (floatValue === undefined) return true;
                        if (floatValue < 0) return false;

                        // Calculate max allowed shares
                        const totalAssignedShares =
                          nodeData.shareHolders.reduce(
                            (acc, item) =>
                              acc + parseFloat(item.numberSharesOwned || 0),
                            0
                          ) +
                          nodeData.JointVentureCompanies.reduce(
                            (acc, item, i) =>
                              i !== index
                                ? acc + parseFloat(item.numberSharesOwned || 0)
                                : acc,
                            0
                          );
                        let maxAllowed =
                          nodeData.totalNoOfShares - totalAssignedShares;
                        handleJointChange(
                          index,
                          "numberSharesOwned",
                          maxAllowed
                        );

                        return floatValue <= maxAllowed;
                      }}
                    />
                  </Grid>

                  <Grid item xs={8} sm={4}>
                    <TextField
                      label="Percentage of Shares"
                      variant="outlined"
                      size="small"
                      type="text"
                      name="PercentageOfShares"
                      value={
                        parseFloat(shareholder.PercentageOfShares).toFixed(2) +
                        "%"
                      }
                      disabled
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={4} sm={1}>
                    <DeleteIcon
                      style={{
                        fontSize: "30px",
                        color: "#1976d2",
                        cursor: "pointer",
                      }}
                      onClick={() => deleteJoint(index)}
                    />
                  </Grid>
                </Grid>
              ))}
            </>
          )}

          {nodeData?.isJointVentureCompany === true && (
            <Grid item xs={12}>
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                color="primary"
                size="medium"
                endIcon={<AddIcon />}
                onClick={handleAddShareCompany}
                disabled={sharedata === 0}
              >
                Add Company
              </Button>
            </Grid>
          )}
          <Grid item xs={12} container sx={{ mb: 8 }}>
            <ReactQuill
              value={nodeData.Remarks || ""} // Bind value to state, ensure it's a string
              onChange={handleRemarksChange} // Update state on change
              modules={{
                toolbar: [
                  // Headers and font size
                  [
                    { header: "1" },
                    { header: "2" },
                    { font: [] },
                    { size: [] },
                  ],
                  // Text formatting
                  ["bold", "italic", "underline", "strike", "blockquote"],
                  // Lists and alignment
                  [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
                  // Color and background color
                  [{ color: [] }, { background: [] }],
                  // Links and clear formatting
                  ["link"],
                  ["clean"], // Clear formatting
                ],
              }}
              placeholder="Enter remarks here..."
              style={{
                width: "100%", // Takes full width of the container
                height: "200px", // Custom height
              }}
            />
          </Grid>

          {nodeData.shareHolders?.map((shareholder, index) => (
            <Grid
              container
              spacing={1}
              rowSpacing={2}
              key={index}
              style={{ marginTop: "5px", marginLeft: "8px" }}
              alignItems="center"
            >
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  // options={parentOptions}
                  options={(() => {
                    // Get all selected company IDs from other rows (excluding current row)
                    const selectedIds = nodeData.shareHolders
                      ?.map((sh, idx) => idx !== index ? sh.childId : null)
                      .filter(Boolean) || [];

                    // Filter parent options to exclude already selected companies
                    return parentOptions.filter(
                      (item) => !selectedIds.includes(item.value)
                    );
                  })()}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Shareholder"
                      size="small"
                      variant="outlined"
                      error={Boolean(errors.shareholders[index]?.childId)}
                      helperText={errors.shareholders[index]?.childId}
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleShareHolderChange(
                      index,
                      "childId",
                      newValue?.value || ""
                    );
                  }}
                  value={
                    parentOptions?.find(
                      (option) => option.value === shareholder.childId
                    ) || null
                  }
                  renderOption={(props, option) => (
                    <li {...props} key={option.value}>
                      {option.label}
                    </li>
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <NumericFormat
                  value={parseFloat(shareholder.numberSharesOwned) || 0}
                  thousandSeparator
                  customInput={TextField}
                  label="Number of Ordinary Shares Owned"
                  size="small"
                  variant="outlined"
                  fullWidth
                  error={Boolean(errors.shareholders[index]?.numberSharesOwned)}
                  helperText={errors.shareholders[index]?.numberSharesOwned}
                  onValueChange={(values) => {
                    let value = parseFloat(values.value) || 0;

                    // Calculate the total shares already allocated to other shareholders and joint venture companies
                    let totalAllocatedShares =
                      nodeData.shareHolders.reduce(
                        (acc, item, i) =>
                          i !== index
                            ? acc + parseFloat(item.numberSharesOwned || 0)
                            : acc,
                        0
                      ) +
                      nodeData.JointVentureCompanies.reduce(
                        (acc, item) =>
                          acc + parseFloat(item.numberSharesOwned || 0),
                        0
                      );

                    // Maximum allowed shares for this shareholder
                    let maxAllowed =
                      nodeData.totalNoOfShares - totalAllocatedShares;

                    // If the entered value exceeds the maximum allowed, set it to the max allowed
                    if (value > maxAllowed) {
                      console.log(
                        "exceeds max allowed, setting to max:",
                        maxAllowed
                      );
                      value = maxAllowed;
                    }
                    console.log("Validated number of shares:", value);
                    // Update the state with the validated number of shares
                    handleShareHolderChange(index, "numberSharesOwned", value);
                  }}
                  isAllowed={(values) => {
                    const { floatValue } = values;
                    if (floatValue === undefined) return true;
                    if (floatValue < 0) return false;

                    // Calculate max allowed shares
                    let totalAllocatedShares =
                      nodeData.shareHolders.reduce(
                        (acc, item, i) =>
                          i !== index
                            ? acc + parseFloat(item.numberSharesOwned || 0)
                            : acc,
                        0
                      ) +
                      nodeData.JointVentureCompanies.reduce(
                        (acc, item) =>
                          acc + parseFloat(item.numberSharesOwned || 0),
                        0
                      );
                    let maxAllowed =
                      nodeData.totalNoOfShares - totalAllocatedShares;
                    handleShareHolderChange(
                      index,
                      "numberSharesOwned",
                      maxAllowed
                    );

                    return floatValue <= maxAllowed;
                  }}
                />
              </Grid>

              <Grid item xs={8} sm={4}>
                <TextField
                  label="Percentage of Ordinary Shares"
                  variant="outlined"
                  size="small"
                  type="text"
                  name="PercentageOfShares"
                  value={
                    parseFloat(shareholder.PercentageOfShares).toFixed(2) + "%"
                  }
                  disabled
                  fullWidth
                />
              </Grid>

              <Grid item xs={4} sm={1}>
                <DeleteIcon
                  style={{
                    fontSize: "30px",
                    color: "#1976d2",
                    cursor: "pointer",
                  }}
                  onClick={() => deleteShareholder(index)}
                />
              </Grid>

              {/* New Fields Start Here */}
              {nodeData?.totalIssuedPreferenceShares > 0 && (
                <>
                  <Grid item xs={12} sm={4}>
                    <NumericFormat
                      value={
                        parseFloat(shareholder.numberofpreferenceshares) || 0
                      }
                      thousandSeparator
                      customInput={TextField}
                      label="Number of Preference Shares Owned"
                      size="small"
                      variant="outlined"
                      fullWidth
                      error={Boolean(
                        errors.shareholders[index]?.numberofpreferenceshares
                      )}
                      helperText={
                        errors.shareholders[index]?.numberofpreferenceshares
                      }
                      onValueChange={(values) => {
                        let value = parseFloat(values.value) || 0;

                        // Calculate the total shares already allocated to other shareholders
                        let totalAllocatedShares = nodeData.shareHolders.reduce(
                          (acc, item, i) =>
                            i !== index
                              ? acc +
                              parseFloat(item.numberofpreferenceshares || 0)
                              : acc,
                          0
                        );

                        // Maximum allowed shares for this shareholder
                        let maxAllowed =
                          nodeData.totalIssuedPreferenceShares -
                          totalAllocatedShares;

                        // If the entered value exceeds the maximum allowed, set it to the max allowed
                        if (value > maxAllowed) {
                          value = maxAllowed;
                        }

                        // Update the state with the validated number of shares
                        handleShareHolderChange(
                          index,
                          "numberofpreferenceshares",
                          value
                        );
                      }}
                      isAllowed={(values) => {
                        const { floatValue } = values;
                        if (floatValue === undefined) return true;
                        if (floatValue < 0) return false;

                        // Calculate max allowed shares
                        let totalAllocatedShares = nodeData.shareHolders.reduce(
                          (acc, item, i) =>
                            i !== index
                              ? acc +
                              parseFloat(item.numberofpreferenceshares || 0)
                              : acc,
                          0
                        );
                        let maxAllowed =
                          nodeData.totalIssuedPreferenceShares -
                          totalAllocatedShares;
                        handleShareHolderChange(
                          index,
                          "numberofpreferenceshares",
                          maxAllowed
                        );

                        return floatValue <= maxAllowed;
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Percentage of Preference Shares"
                      size="small"
                      variant="outlined"
                      type="text"
                      name="PercentageOfShares"
                      value={
                        parseFloat(
                          shareholder.percentageofpreferanceshares
                        ).toFixed(2) + "%"
                      }
                      disabled
                      fullWidth
                      onChange={(e) => {
                        handleShareHolderChange(
                          index,
                          "percentageofpreferanceshares",
                          e.target.value
                        );
                      }}
                      error={Boolean(
                        errors.shareholders[index]?.percentageofpreferanceshares
                      )}
                      helperText={
                        errors.shareholders[index]?.percentageofpreferanceshares
                      }
                      inputProps={{ min: 0 }}
                    />
                  </Grid>
                </>
              )}
              {/* End here */}
            </Grid>
          ))}

          <Grid
            container
            // spacing={2}
            justifyContent="space-between"
            alignItems="center"
            sx={{ padding: "1px", marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <Button
                sx={{ ml: 2, mr: 1 }}
                variant="contained"
                color="primary"
                size="medium"
                endIcon={<AddIcon />}
                onClick={handleAddShareHolder}
                disabled={sharedata === 0}
              >
                Add ShareHolder
              </Button>
            </Grid>

            <Grid
              item
              xs={6}
              container
              alignItems="center"
              justifyContent="flex-end"
            >
              <Grid item>
                <NumericFormat
                  value={sharedata}
                  thousandSeparator
                  customInput={TextField}
                  label="Remaining Shares"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Button
              sx={{ mr: 1 }}
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              fullWidth
            // disabled={sharedata !== 0}
            >
              Submit
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              sx={{ mr: 1 }}
              onClick={handleClickOpen}
              variant="outlined"
              fullWidth
            // disabled={sharedata !== 0}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </div>
      {loading && <LoadingOverlay open={loading} />}
    </>
  );
}
